import { render, staticRenderFns } from "./CustomersService.vue?vue&type=template&id=bc4d0dc2&"
import script from "./CustomersService.vue?vue&type=script&lang=js&"
export * from "./CustomersService.vue?vue&type=script&lang=js&"
import style0 from "./CustomersService.vue?vue&type=style&index=0&id=bc4d0dc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports